(() => {
  'use strict';
  const dialog = document.getElementById('MerchSignup');
  if (dialog && typeof dialog.showModal === 'function') {
    const completedKey = 'aws-newsletter-completed';
    const dismissedKey = 'aws-newsletter-dismissed';
    const read = (storage, key) => { try { return window[storage].getItem(key) === '1'; } catch { return false; } };
    const write = (storage, key) => { try { window[storage].setItem(key, '1'); } catch {} };
    const designMode = dialog.dataset.designMode === 'true';
    const success = dialog.querySelector('[data-signup-success]');
    const errors = dialog.querySelector('[data-signup-errors]');
    const open = () => {
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('signup-open');
      (success || dialog.querySelector('input[type="email"]'))?.focus({preventScroll:true});
    };
    const close = () => dialog.close();
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('signup-open');
      if (!designMode) write('sessionStorage', dismissedKey);
    });
    dialog.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    });
    document.querySelectorAll('[data-merch-link]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!designMode && (dialog.dataset.subscribed === 'true' || read('localStorage', completedKey) || read('sessionStorage', dismissedKey))) return;
        event.preventDefault(); open();
      });
    });
    // Only Shopify's rendered success confirms subscription; a click is never enough.
    if (success) {
      if (!designMode) write('localStorage', completedKey);
      open();
    } else if (errors) {
      open();
    } else if (!designMode && dialog.dataset.subscribed !== 'true' && !read('localStorage', completedKey) && !read('sessionStorage', dismissedKey)) {
      // Immediate entry popup, once per browsing session, with no scroll or timer.
      open();
    }
  }
  const selector = document.querySelector('[data-variant-select]');
  if (selector) {
    const update = () => {
      const option = selector.selectedOptions[0];
      if (!option) return;
      const price = document.querySelector('[data-product-price]');
      const button = document.querySelector('[data-add-button]');
      if (price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
      }
    };
    selector.addEventListener('change', update);
    update();
  }
})();
